/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { HotelBuilding } from './building.model';
import { ProfileModel } from './profile.model';
import { RequestLineModel } from './request-line.model';
import { FormField, MenuItem } from './rich-data.model';
import { TaskType } from './task-type.model';

export class RequestHeaderModel {
    id: number;
    hotel_id: number;
    profile_id: number; // Misafir örneğin Rezervasyon kimin adına yapılıyor. (Source by)
    profile_name: string;
    profile_picture: string;
    email: string;
    phone_no: string;
    locale: string;
    room_no: string;
    note: string; // Misafirin yazdığı not
    type: string; // room_service, reservation, reservation_to_facility, housekeeping_request, complaint, issue, premium_service, restaurant_order
    payment_type: string; // Cash,Debit,Card,Online
    line_type: string;
    reservation_type: string; // Menu item name, örneğin; yat turu yazacak
    start_date: Date | string;
    end_date: Date | string;
    capacity_name: string;
    room_count: number;
    approval_status: string; // Onay Durumu : none,pending,approved,rejected
    menu_section_id: number;
    menu_section_name: string;
    menu_category_id: number;
    menu_category_name: string;
    menu_item_id: number;
    menu_item_name: string;
    point: number;
    order_date: Date | string;
    status: string;
    staff_note: string;  // Staff ın aldığı not
    requestlines: RequestLineModel[];
    request_summary:any;
    notify_action: string;  // enu=Notify Action;trk=Bildirim Aksiyonu" "Burada belirtilecek aksiyona göre misafire push notificaion gönderilecek.
    rate: number;
    place_code: string;
    hotel_name: string;
    message_badge: number;
    profile_visit_status: string;
    profile_visit_id: number;
    additional_form_fields: AdditionalFormField[];
    guest: Guest;
    actions: Action[];
    reservation_quantity: number;  // Kaç kişilik rezervasyon
    duration: number;  // Dakika cinsinde buna göre end date atanacak gerçekten kalkınca endate ve duration güncellenecek.
    menu_item_capacities: string[]; // Array olarak masa id ler tutulacak.
    booked_user_type: string;  // Reservasyonu yapan Kullanıcı tipi (Booked By) User,Profile
    booked_user_id: number;  // Reservasyonu yapan id
    booked_user_name: string;  // Rezervasyonu yapan adı
    booked_profile_picture: string;  // Rezervasyonu yapanın Resmi
    booked_e_mail: string;  // Rezervasyonu yapanın Email adresi
    booked_phone_no: string;  // Rezervasyonu yapanın Telefon Numarası
    booked_company_name: string;  // Rezervasyonu yapanın Şirket Adı
    perks: string;  // Avantaj olarak şampanya bedavadan verelim gibi bir laf yazacaklar.
    send_request_notification_email_now: boolean;  // Notification Mail i atılacak mı
    request_notification_personal_message: string;  // Atılacak mail de kişiye atılacak olan özel mesaj
    send_request_notification_booked: boolean;  // Rezervasyonu yapana mı atılacak
    send_request_notification_profile: boolean;  // Rezervasyon yapılana mı atılacak.
    send_request_notification_email_sms: boolean;  // Hatırlatma Sms mesajı atılacak mı.
    send_request_notification_sms_booked: boolean;  // Misafire Rezervasyon onaylandı SMS Mesajı Gönder
    send_request_notification_sms_profile: boolean;  // Misafire SMS Hatırlatıcı Gönder
    send_reminder_email_now: boolean;  // Hatırlatma Mail i atılacak mı
    send_reminder_booked: boolean;  // Rezervasyon onaylandı
    send_reminder_profile: boolean;  // Misafire hatırlatma maili gönder
    send_feed_back_email_now: boolean;  // Masadan kalktıktan sonra Feedback mesajı atılacak mı.
    send_feed_back_booked: boolean;  // Rezervasyonun onaylanmasından sonra bilgilendirme maili gönder
    send_feed_back_profile: boolean;  // Misafire geri bildirim anketi gönder
    voucher_no: string;  // Rezervasyon fiş no. bunu no series management den üretelim.
    menu_item_book_detail_id: number;  // Shift ID
    menu_item_book_detail_name: string;  // Shift Name
    location: string;  // Deniz kenarı masa, Bardaki masa, Otel bazında seçmeli olmalı.
    floor: string;  // Kaçıncı katta
    profile_company_name: string;  // Şirket Adı
    server_type: string;  // Servisi yapan kişininin tipi User,Profile
    server_id: number;  // Servisi yapan ID Garson ID
    server_name: string;  // Garsonun Adı
    hostess_type: string;  // Hostes in kullanıcı tipi User,Profile
    hostess_id: number;  // HostesID Rezervasyonu kaydeden
    hostess_name: string;  // Hostesin adı
    commission_holder_type: string;  // Komisyona konu kişinin tipi. User,Profile
    commission_holder_id: number;  // Komisyona konu kişi
    commission_holder_name: string;  // Komisyona konu kişi adı
    code: string;
    work_order_type: string; // İş Emri Türü (Service, Request, Incident, Reading, Inspection, PM Order, Call Back, Log)
    task_type_id: number;  // Görev Türü (Task Type tablosu ile ilişkili)
    task_template_id: number;  // Görev Şablonu (Task Template Tablosu ile ilişkili)
    task_type: string;  // Görev Türü (Internal, External). Eğer task template ID tanımlıysa task temaplateden otomatik olarak kopyalanır. Eğer Task type tanımlıysa otomatik olarak task typedan kopyalanır. Misafirlerin gönderdiklerinde external yazıyor."`
    task_category: string;  // Görev Türü (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır. Eğer Task type tanımlıysa otomatik olarak task typedan kopyalanır.)
    task: string;  // Görev (ENG)  (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır. Eğer Task type tanımlıysa otomatik olarak task typedan kopyalanır.)
    task_locale: string;  // Görev (TR)  (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır. Eğer Task type tanımlıysa otomatik olarak task typedan kopyalanır.)
    task_description: string;  // Görev Açıklaması (ENG) (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır. Eğer Task type tanımlıysa otomatik olarak task typedan kopyalanır.)
    task_description_locale: string;  // Görev Açıklaması (TR) (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır. Eğer Task type tanımlıysa otomatik olarak task typedan kopyalanır.)
    issue: string;  // Sorun (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır.)
    issue_detail: string;  // Sorun Detay (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır.)
    asset_id: number;  // İlgili Varlık (Eğer task template ID tanımlıysa task templateden otomatik olarak kopyalanır.)
    asset_name: string;  // Varlık Adı (İlgili Asset Kaydının Description alanı)
    building_id: number;  // Konum ID
    building_name: string;  // Konum Buildingteki Konum ile ilişkili. Eğer bu şablon sadece bir No ile alakalıysa doğrudan seçilir -Eğer task template ID tanımlıysa task temaplateden otomatik olarak kopyalanır.
    area_id: number;  // Bölge ID Alpha Num Codes (Buildingteki Area ile ilişkili. Eğer bu şablon sadece bir bölge ile alakalıysa doğrudan seçilir -Eğer task template ID tanımlıysa task temaplateden otomatik olarak kopylanır.)
    area: string;  // Bölge Adı Buildingteki (LocationID) Area ile ilişkili. Eğer bu şablon sadece bir bölge ile alakalıysa doğrudan seçilir
    department_id: number;  // Departman ID
    department_name: string;  // Departman Adı Eğer task template ID tanımlıysa task temaplateden otomatik olarak kopyalanır.
    priority_id: number;  // Öncelik ID : Alpha Num Codes (Yüksek,Orta,Düşük)
    priority: string;  // Öncelik Durumu Eğer task template ID tanımlıysa task temaplateden otomatik olarak kopyalanır.
    before_reminder: number;  // Önceden Hatırlat Değeri 15 dakika gibi : İş başlamadan ne kadar önce sürede hatırlatma yapılacak
    before_reminder_type: string;  // Önceden Hatırlatma Türü : minute, hour, day, week, month, year
    labor_estimated_time: number;  // İşin tahmini ne kadar sürede tamamlanacağı. : Task Type tablosundan Required Time alanından gelecek
    labor_estimated_time_type: 'minute' | 'hour' | 'day' | 'week' | 'year' | 'month';  // İşin tahmini ne kadar sürede tamamlanacağı. : minute, hour, day, week, month, year  : Task Type tablosundan Required Time alanından gelecek
    default_cost: number;  // İşin tahmini maliyeti
    attachment: AwsContent[]; // İş için gerekli olan dokümanlar. Apide dosya yükleme endpointi olmalı.
    remarks: string;  // İş ile ilgili detay notlar. Bu alan Note apisi ile çalışacak.
    steps: number;  // İş ile ilgili alt kontrol adımları
    parts: number;  // İş ile ilgili gereken yedek parça sayısı
    costs: number;  // İş ile ilgili gereken maliyetler tutarı
    reading: number;  // İş ile ilgili gereken ölçümler
    assigned_type: string;  // Atama Türü : Departman, Takım, Personel
    assigned_department_id: number;  // İş bir departmana atanmışsa seçilir diğer atma alanları unvisible olur
    assigned_department_name: string;  // İş bir departmana atanmışsa seçilir diğer atma alanları unvisible olur
    assigned_team_id: number;  // İş bir takıma atanmışsa seçilir diğer atma alanları unvisible olur
    assigned_team_name: string;  // İş bir takıma atanmışsa seçilir diğer atma alanları unvisible olur
    assigned_person_id: number;  // İş bir personele atanmışsa seçilir diğer atma alanları unvisible olur
    assigned_person_name: string;  // İş bir personele atanmışsa seçilir diğer atma alanları unvisible olur.:
    recurring: boolean;  // Yenilenen iş olup olmadığı seçililir Ture/false
    recurring_period_option: string;  // Yenileme Sıklığı Opsiyonu : none, Before Checkout, After Checkout, Before Checkin, After Checkin
    recurring_period_type: string;  // Yenileme sıklığı belirtilir
    recurring_period: number;  // Yenileme sıklığı
    auto_escalation: boolean;  // Otomatik eskalasyon yapılıp yapılmayacağı True/false : Task Type tablosundan gelecek
    escalation_period_1: number;  // Eskalasyon Periyodu 1
    escalation_period_type_1: string;  // Eskalasyon Periyodu Türü 1 : minute, hour, day, week, month, year : Task Type tablosundan gelecek
    escalation_person_1_id: number;  // Eskalasyon Kişi 1
    escalation_period_2: number;  // Eskalasyon Periyodu 2
    escalation_period_type_2: string;  // Eskalasyon Periyodu Türü 2 : minute, hour, day, week, month, year : Task Type tablosundan gelecek
    escalation_person_2_id: number;  // Eskalasyon Kişi 2
    escalation_period_3: number;  // Eskalasyon Periyodu 3
    escalation_period_type_3: string;  // Eskalasyon Periyodu Türü 3 : minute, hour, day, week, month, year : Task Type tablosundan gelecek
    escalation_person_3_id: number;  // Eskalasyon Kişi 3
    total_step_point: number;  // Task Step tablosundaki Ansver Value değerlerinin toplamı
    total_cost: number;  // Task Cost tablosundaki Cost değerlerinin toplamı
    total_part_cost: number;  // TaskParts tablosundaki Cost değerlerinin toplamı
    created_at: Date;  // Oluşturma Tarihi
    created_by: number;  // Kaydı Oluşturan
    updated_at: Date;  // Değişiklik Tarihi
    updated_by: number;  // Kaydı Değiştiren
    read: boolean;  // Okundu
    read_at: Date;  // Okuma Zamanı
    read_by_user_id: number;  // Kaydı Açıp Okuyan/Gören Kullanıcı ID
    read_by_user: string;  // Okuyan Kullanıcı
    in_the_process: boolean;  // Başladı
    in_the_process_at: Date;  // Başlama Zamanı
    in_the_process_by_user_id: number;  // Başlatan Kullanıcı ID
    in_the_process_by_user: string;  // Başlatan Kullanıcı
    paused: boolean;  // Durduruldu
    paused_by_user_id: number;  // Durduran Kullanıcı ID
    paused_user: string;  // Durduran/Beklemeye Alan Kullanıcı
    paused_start_at: Date;  // Durdurma Başlangıç Zamanı
    paused_end_at: Date;  // Durdurma Bitiş Zamanı
    pause_value: string;  /* Durdurma Nedeni : Durma nedeni, task type ta bulunan değerlerden biri seçilir.
     Eğer task template ID tanımlıysa task templateden seçilir*/
    managed: boolean;  // Tamamlandı
    managed_at: Date;  // Tamamlanma Zamanı
    managed_by_user_id: number;  // Tamamlayan Kullanıcı ID
    managed_by_user: string;  // Tamamlayan Kullanıcı
    closing_value: string;
    void: boolean;  // Geçersiz
    void_at: Date;  // Görevin geçersiz olma zamanı
    void_by_user_id: number;  // Görevin geçersiz olduğunu belirten Kullanıcı ID
    void_by_user: string;  // Görevin geçersiz olduğunu belirten kullanıcı
    deferred: boolean;  // Ertelendi
    deferred_at: Date;  // Görev ne zaman Ertelendi
    deferred_by_user_id: number;  // Görevi kim Erteledi ID
    deferred_by_user: string;  // Görevi kim Erteledi
    deferred_duration_type: string;  //  minute, hour, day, week, month, year
    deferred_duration: number;  // Görevi ne kadar süre erteledi
    rejected: boolean;  // İptal
    rejected_at: Date;  // Görevi ne zaman iptal etti
    rejected_by_user_id: number;  // Görevi kim iptal etti ID
    rejected_by_user: string;  // Görevi kim iptal etti
    escalation_1_date_time: Date;  // Eğer görev eskalasyona girdiyse 1. eskalasyon zamanı
    escalation_2_date_time: Date;  // Eğer görev eskalasyona girdiyse 2. eskalasyon zamanı
    escalation_3_date_time: Date;  // Eğer görev eskalasyona girdiyse 3. eskalasyon zamanı
    reminded: boolean;
    solution_note: string;  // Görevin nasıl çözüldüğü ile ilgili detay not girme alanı
    after_close_task_who_callback_user_id: number;  // Görev kapandıktan sonra memnuniyet için arayan kullanıcı
    callback_date_after_close_task: Date;  // Görev kapandıktan sonra memnuniyet için arama tarihi
    callback_note: string;  // Görev kapandıktan sonra memnuniyet için aramada misafirin ilettiği not
    callback_survey_rating: number;  // Görev kapandıktan sonra memnuniyet puanı
    elapsedTime: number;
    remainingTime: number;
    created_by_department_id: number;
    pause_description: string;
    menu_item_capacity_id: number;
    total_amount: number;
    currency_code: string;

    constructor(
        profile: ProfileModel,
        note: string,
        type: string,
        resType: string,
        menuItem: MenuItem,
        sectionName: string,
        categoryName: string,
        itemName: string,
        orderDate: Date | string,
        formFields: FormField[],
        lineType?: string,
        taskType?: TaskType,
        building?: HotelBuilding,
    ) {
        this.id = 0;
        this.hotel_id = profile.hotel_id;
        this.profile_id = profile.id;
        this.profile_name = `${profile.first_name} ${profile.last_name}`;
        this.profile_picture = profile.profile_pic_url;
        this.email = profile.e_mail;
        this.phone_no = profile.phone_no;
        this.locale = profile.locale;
        this.room_no = profile.room_no;
        this.line_type = lineType || '';
        this.note = note;
        this.type = type;
        this.reservation_type = resType;
        this.start_date = new Date().toISOString();
        this.end_date = new Date().toISOString();;
        this.room_count = 0;
        this.approval_status = 'pending';
        this.menu_section_id = menuItem.menu_section_id;
        this.menu_section_name = sectionName;
        this.menu_category_id = menuItem.menu_category_id;
        this.menu_category_name = categoryName;
        this.menu_item_id = menuItem.id;
        this.menu_item_name = itemName;
        this.point = 0;
        this.order_date = orderDate;
        this.status = status;
        this.notify_action = 'Guest';
        this.staff_note = '';
        this.read = false;
        this.read_at = new Date();
        this.read_by_user = '';
        this.in_the_process = false;
        this.in_the_process_by_user = '';
        this.in_the_process_at = new Date();
        this.managed = false;
        this.managed_at = new Date();
        this.managed_by_user = '';
        this.requestlines = [];
        this.additional_form_fields = [];

        if (formFields && formFields.length > 0) {
            for (const form of formFields) {
                const FIELD = new AdditionalFormField(form);
                this.additional_form_fields.push(FIELD);
            }
        }

        if (taskType) {
            this.task_type_id = taskType.id;
            this.task_type = taskType.type;
            this.task_category = taskType.task_category_name;
            this.task = taskType.task_name;
            this.task_locale = taskType.task_name_locale;
            this.task_description = taskType.task_description;
            this.task_description_locale = taskType.task_description_locale;
            this.department_id = taskType.department_id;
            this.department_name = taskType.department_name;
            this.auto_escalation = taskType.auto_escalation;
            this.escalation_period_1 = taskType.escalation_period_1;
            this.escalation_period_type_1 = taskType.escalation_period_type_1;
            this.escalation_person_1_id = taskType.escalation_person_1_id;
            this.escalation_period_2 = taskType.escalation_period_2;
            this.escalation_period_type_2 = taskType.escalation_period_type_2;
            this.labor_estimated_time = taskType.required_time;
            this.labor_estimated_time_type = taskType.required_time_type as any || 'minute';
            this.escalation_person_2_id = taskType.escalation_person_2_id;
            this.escalation_period_3 = taskType.escalation_period_3;
            this.escalation_period_type_3 = taskType.escalation_period_type_3;
            this.escalation_person_3_id = taskType.escalation_person_3_id;
            this.solution_note = '';
            this.after_close_task_who_callback_user_id = 0;
            this.callback_date_after_close_task = new Date();
            this.callback_note = '';
            this.assigned_team_id = taskType.team_id;
            this.assigned_team_name = taskType.team_name;

            if (building) {
                this.building_name = building.name;
                this.building_id = building.id;
                this.area = building.area;
                this.area_id = building.area_id;
                this.floor = building.floor;
                this.location = building.name;
            }
        }
    }

}

export class AdditionalFormField {
    id: number;
    request_header_id: number;
    request_line_id: number;
    form_field_id: number;
    field_caption: string;
    field_value: string;
    created_at: Date | string;
    updated_at: Date | string;

    constructor(form: FormField) {
        this.id = 0;
        this.request_header_id = 0;
        this.request_line_id = 0;
        this.form_field_id = form.id;
        this.field_caption = form.field_caption;
        this.field_value = form.value?.toString();
        this.created_at = new Date().toISOString();
        this.updated_at = new Date().toISOString();
    }
}

interface RequestAction {
    id: number;
    no: number;
    created_time: Date;
    description: string;
    current_status: string;
    state: string;
    user_id: number;
}
interface Action {
    id: number;
    no: number;
    created_time: Date;
    description: string;
    current_status: string;
    state: string;
    user_id: number;
}

interface Guest {
    id: number;
    hotel_id: number;
    full_name: string;
    title: string;
    first_name: string;
    last_name: string;
    voucher: string;
    tc_no: string;
    date_of_birth: string;
    nationality: string;
    passport_no: string;
    mobile: string;
    email: string;
    proficiency: string;
    sex: string;
    rec_id: number;
    checkin_date: string;
    check_out_date: string;
    room_number: string;
    created_at: string;
    updated_at: string;
    status: string;
    note: string;
    agency_id: number;
    agency_name: string;
    repeat: number;
    pax: number;
    market_code: string;
    channel: string;
    room_price: number;
    daily_room_price: number;
    reservation_id: number;
    currency_code: string;
    dinner_rev: number;
    breakfast_rev: number;
    lunch_rev: number;
    other_rev: number;
    extra_rev: number;
    package_rev: number;
    total_rev: number;
    share_amount: number;
    exchange_rate: number;
    reservation_exchange_rate: number;
    reservation_status: string;
    room_category_id: number;
    room_category_name: string;
    board_type: string;
    company_name: string;
    company_id: number;
    source_name: string;
    source_id: number;
    adults: number;
    children: number;
    children_1: number;
    children_2: number;
    children_3: number;
    children_4: number;
    children_5: number;
    single: number;
    double: number;
    triple: number;
    quadro: number;
    individual_room: number;
    source_room: number;
    company_room: number;
    travel_agent_room: number;
    nights: number;
    last_room_no: string;
    room_class: string;
    room_category_label: string;
    guest_language: string;
    address_type: string;
    address: string;
    city: string;
    country: string;
    registration_card_no: string;
    exchange_date: string;
    base_rate_amount: number;
    payment_amount: number;
    fb_revenue: number;
    room_revenue: number;
    total_revenue: number;
    walk_in_yn: boolean;
    group_id: number;
    group_name: string;
    origin_of_booking: string;
    origin_of_booking_desc: string;
    reservation_insert_source: string;
    reservation_insert_source_type: string;
    market_desc: string;
    external_reference: string;
    external_reference_type: string;
    insert_date: string;
    award_membership_id: number;
    award_code: string;
    points: number;
    vip: string;
    vip_desc: string;
    reservation_date: string;
}

interface AwsContent {
    id: number;
    table_name: string;
    type: string;
    table_record_id: number;
    attachment_url: string;
    priority: number;
    name: string;
    description: string;
    link: string;
}
